import React from 'react';
import RightSidebar, {
  Props as RightSidebarProps,
} from '~src/components/RightSidebar';
import ContactForm, {
  Props as ContactFormProps,
} from '~apartments/components/ContactForm';

export type Props = Omit<RightSidebarProps, 'children' | 'className'> &
  ContactFormProps;

const RightSidebarContactForm = ({
  isOpen,
  onClose,
  ...contactFormProps
}: Props) => (
  <RightSidebar isOpen={isOpen} onClose={onClose}>
    <ContactForm {...contactFormProps} />
  </RightSidebar>
);
export default RightSidebarContactForm;
